import React,{Component} from 'react';
import { BrowserRouter as Router,Link  } from 'react-router-dom';

class Bended extends Component{
    
	 
          
    render() {
        
        return (
            <tr key={this.props.index}>            
                <td className="text-left paddingLeft20px">{this.props.details.dimension}</td>                           
                <td className="text-center">P {this.props.details.price_4MM}</td>
                <td className="text-center">P {this.props.details.price_5MM}</td>
                <td className="text-center">P {this.props.details.price_6MM}</td>              
                <td className="text-center">
                <div className="btn-group btn-group-xs">
                    <Link to={`dimension/${this.props.index}/edit`} data-toggle="tooltip" className="btn btn-default"> <i className="fa fa-pencil"></i></Link>
                    <button className="btn btn-xs btn-danger" type="submit" onClick={()=>this.props.removeProduct(this.props.index)}><i className="fa fa-times"></i></button>  
                </div>
              </td>
            </tr>	    
        );
    }
}

export default  Bended;



// WEBPACK FOOTER //
// ./src/components/Bended.js